import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full" data-id="element-384">
    <div className="flex items-center mb-4" data-id="element-385">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-rose font-serif font-bold text-sm md:text-xl border border-brand-pink/30 mr-3 md:mr-4 shrink-0" data-id="element-386">
        {initials}
      </div>
      <div data-id="element-387">
        <div className="flex text-brand-rose mb-1 text-[15px]" data-id="element-388">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-389" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-390">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-391">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px]" data-id="element-392">"{text}"</p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials: TestimonialProps[] = [{
    initials: 'PR',
    name: 'Patricia R.',
    location: 'Mendoza',
    text: 'Las planillas de evolución cambiaron todo. Ahora mis pacientes ven su progreso en números reales.'
  }, {
    initials: 'FM',
    name: 'Florencia M.',
    location: 'Buenos Aires',
    text: 'El consentimiento informado y las fichas le dieron a mi consultorio un nivel profesional que antes no tenía.'
  }, {
    initials: 'CC',
    name: 'Carla C.',
    location: 'La Plata',
    text: 'Nunca más le pregunté a un paciente qué habíamos trabajado la vez anterior. La sesión fluye diferente.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-393">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-394">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-395" />)}
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'LG',
    name: 'Lucía G.',
    location: 'Mendoza',
    product: 'Kit REFLEXO-PRO Completo',
    text: 'Las planillas de evolución cambiaron todo. Ahora mis pacientes ven su progreso en números reales y no abandonan el tratamiento.'
  }, {
    initials: 'MT',
    name: 'Marina T.',
    location: 'Buenos Aires',
    product: 'Terapeuta en Reflexología',
    text: 'El consentimiento informado y las fichas de anamnesis le dieron a mi consultorio un nivel de profesionalismo que antes no tenía. Los pacientes lo notan desde la primera sesión.'
  }, {
    initials: 'VS',
    name: 'Valentina S.',
    location: 'La Plata',
    product: 'Terapeuta en Reflexología',
    text: 'Nunca más le pregunté a un paciente qué habíamos trabajado la vez anterior. Ahora tengo todo registrado y la sesión fluye diferente.'
  }, {
    initials: 'RB',
    name: 'Romina B.',
    location: 'Neuquén',
    product: 'Terapeuta en Reflexología',
    text: 'El sistema de control de stock del Bonus 2 es brillante. Simple, rápido y evita exactamente ese estrés de llegar al consultorio y que falte algo.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-396">
      <div className="text-center mb-12" data-id="element-397">
        <h2 className="md:text-4xl font-serif font-bold mb-4 text-[24px]" data-id="element-398">
          ❤️ TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] max-w-4xl mx-auto" data-id="element-399">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-400" />)}
      </div>
    </Section>;
};